import { useEffect } from 'react';
import b64images from '~/public/squishies.base64.json';

let initialized = false;

const initialize = () => {
  const style = document.createElement('style');
  const variables = b64images
    .map(item => `--squishy-background-${item.id}: url(data:image/webp;base64,${item.data});`)
    .join('\n')
  const rules = b64images
    .map(item => `[data-squishy-background="${item.id}"] { background-image: var(--squishy-background-${item.id}); }`)
    .join('\n')
  style.innerHTML = `
:root {
  ${variables}
}

${rules}
`;
  document.head.appendChild(style);
};

export const SquishyBackgroundVariables = () => {
  useEffect(() => {
    if (initialized) return;
    initialized = true;
    initialize();
  }, []);
  return null;
};